export default __webpack_public_path__ + "static/media/Kano.f79fa125.otf";